import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";

import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { SnackBarService } from "#services/snackbar.service";
import { NotificationService } from "@carnegie-learning/data-access-angular-passport";
import * as notificationsActions from "../actions/notifications.actions";

@Injectable()
export class NotificationsEffects {
    constructor(
        private actions$: Actions,
        private notificationService: NotificationService,
        private snackBarService: SnackBarService
    ) {}


    loadNotifications$ = createEffect(() => this.actions$
        .pipe(ofType(notificationsActions.LOAD_NOTIFICATIONS))
        .pipe(
            map(
                (action: notificationsActions.LoadNotifications) =>
                    action.payload
            ),
            // payload here is the notification type (announcement, pm,...)
            switchMap(payload => {
                return this.notificationService.getNotifications(payload).pipe(
                    map((notifications) => {
                        if (notifications.body) {
                            return new notificationsActions.LoadNotificationsSuccess(
                                notifications.body
                            );
                        } else {
                            return new notificationsActions.LoadNotificationsFail(
                                    notifications
                                )
                        }
                    }),
                    catchError(error =>
                        of(
                            new notificationsActions.LoadNotificationsFail(
                                error
                            )
                        )
                    )
                );
            })
        ));


    markAsRead$ = createEffect(() => this.actions$
        .pipe(ofType(notificationsActions.MARK_AS_READ))
        .pipe(
            map((action: notificationsActions.MarkAsRead) => action),
            switchMap(action => {
                return this.notificationService.markAsRead(action.payload).pipe(
                    map(notification => {
                        return new notificationsActions.MarkAsReadSuccess(
                            notification.body
                        );
                    }),
                    catchError(error =>
                        of(new notificationsActions.MarkAsReadFail(error))
                    )
                );
            })
        ));
}
